module.exports = __webpack_public_path__ + "img/inspirar.ca43cfcd.jpg";